!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.storeblocks=t():e.storeblocks=t()}(self,(()=>(()=>{"use strict";var e={617:(e,t,o)=>{o.d(t,{default:()=>i});var r=o(15),n=o.n(r),a=o(597),l=o(279);const i=function(e){var{column:t,direction:o,children:i,onClick:c,align:d}=e,s=function(e,t){var o={};for(var r in e)Object.prototype.hasOwnProperty.call(e,r)&&t.indexOf(r)<0&&(o[r]=e[r]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var n=0;for(r=Object.getOwnPropertySymbols(e);n<r.length;n++)t.indexOf(r[n])<0&&Object.prototype.propertyIsEnumerable.call(e,r[n])&&(o[r[n]]=e[r[n]])}return o}(e,["column","direction","children","onClick","align"]);const p=(0,r.useMemo)((()=>{if(!o)return n().createElement(l.EmptyIcon,null);const e="asc"===o?"arrow-up":"arrow-down";return n().createElement(a.SystemIcon,{name:e,size:16,ml:"left"===d?"8px":0,mr:"right"===d?"8px":0})}),[d,o]);return t&&c?n().createElement(l.CellBaseButton,Object.assign({align:d},s),n().createElement("button",{type:"button",onClick:e=>c(e)},"right"===d?p:i,"right"===d?i:p)):n().createElement(l.CellBase,Object.assign({align:d,style:"left"===d?{paddingLeft:"16px"}:{paddingRight:"16px"}},s),i)}},997:(e,t,o)=>{o.d(t,{default:()=>i});var r=o(15),n=o.n(r),a=o(597),l=o(279);const i=function(e){var{expand:t,children:o}=e,i=function(e,t){var o={};for(var r in e)Object.prototype.hasOwnProperty.call(e,r)&&t.indexOf(r)<0&&(o[r]=e[r]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var n=0;for(r=Object.getOwnPropertySymbols(e);n<r.length;n++)t.indexOf(r[n])<0&&Object.prototype.propertyIsEnumerable.call(e,r[n])&&(o[r[n]]=e[r[n]])}return o}(e,["expand","children"]);const[c,d]=(0,r.useState)(!1);return t?n().createElement(n().Fragment,null,n().createElement("tr",Object.assign({},i),n().createElement("td",null,n().createElement(l.ExpandButton,{type:"button","aria-expanded":c,onClick:()=>d(!c)},n().createElement(a.SystemIcon,{name:c?"chevron-up":"chevron-down","aria-label":c?"collapse":"expand",size:16}))),o),c&&t):n().createElement("tr",Object.assign({},i),o)}},279:(e,t,o)=>{o.d(t,{Body:()=>i,CellBase:()=>s,CellBaseButton:()=>d,EmptyIcon:()=>p,ExpandButton:()=>u,Footer:()=>c,Head:()=>l,TableBase:()=>a});const r=require("styled-components");var n=o.n(r);const a=n().table.attrs({className:"table"})`
  width: 100%;
  border-spacing: 0;
  color: var(--color-on-background);

  & > thead {
    vertical-align: top;
  }

  & > thead > tr > td > button > i {
    align-self: flex-start;
  }

  & > thead,
  & > tfoot {
    height: 48px;
    background: var(--color-surface);
    border-top: 1px solid var(--color-border);
    box-sizing: border-box;

    > tr {
      > td {
        font-weight: 700;

        > button {
          display: flex;
          align-items: center;
          width: 100%;
          min-height: 48px;
          font-weight: 700;
          background: none;
          border: none;
          cursor: pointer;
          text-align: left;

          transition-property: background-color, color;
          transition-duration: 0.2s;

          &:hover {
            background: var(--color-surface-hover);
            color: var(--color-primary-variant);
          }

          &:active {
            background: var(--color-surface-pressed);
            color: var(--color-on-background);
          }

          &:focus-visible {
            outline: var(--outline);
            outline-offset: -2px;
          }
        }
      }
    }
  }

  & > tbody > tr {
    &:hover {
      background: var(--color-overlay-hover-darken);
      color: var(--color-primary-variant);
    }

    > td {
      font-size: 16px;
      line-height: 24px;

      padding: 12px 16px;
      border-top: 1px solid var(--color-border);
      /* box-sizing: border-box; */
    }

    &:last-child > td {
      border-bottom: 1px solid var(--color-border);
    }
  }
`,l=n().thead``,i=n().tbody``,c=n().tfoot``,d=(n().tr``,n().td`
  & > button {
    padding: 14px 16px;
  }

  padding: 0;

  ${({align:e})=>"right"===e&&r.css`
      text-align: right;

      & > button {
        justify-content: flex-end;
      }
    `}
`),s=n().td`
  & > button {
    padding: 0;
  }

  padding: 14px 16px;

  ${({align:e})=>"right"===e&&r.css`
      text-align: right;
    `}
`,p=n().div`
  width: 24px;
  height: 16px;
`,u=n().button`
  display: flex;
  justify-content: center;
  align-items: center;

  background: transparent;
  border: none;

  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 0;

  cursor: pointer;
`},880:(e,t,o)=>{o.d(t,{default:()=>n});var r=o(15);const n=function(e=""){const[t,o]=(0,r.useState)({column:e,direction:void 0}),n=(0,r.useCallback)((e=>{t.column===e?o({column:t.column,direction:"asc"===t.direction?"desc":"asc"}):o({column:e,direction:"desc"})}),[t]);return[t,n]}},597:e=>{e.exports=require("@storeblocks/icon")},15:e=>{e.exports=require("react")}},t={};function o(r){var n=t[r];if(void 0!==n)return n.exports;var a=t[r]={exports:{}};return e[r](a,a.exports,o),a.exports}o.n=e=>{var t=e&&e.__esModule?()=>e.default:()=>e;return o.d(t,{a:t}),t},o.d=(e,t)=>{for(var r in t)o.o(t,r)&&!o.o(e,r)&&Object.defineProperty(e,r,{enumerable:!0,get:t[r]})},o.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t),o.r=e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})};var r={};return(()=>{o.r(r),o.d(r,{Body:()=>n.Body,Cell:()=>a.default,Footer:()=>n.Footer,Head:()=>n.Head,Row:()=>i.default,default:()=>d,useSort:()=>l.default});var e=o(15),t=o.n(e),n=o(279),a=o(617),l=o(880),i=o(997);function c(e){var{children:o}=e,r=function(e,t){var o={};for(var r in e)Object.prototype.hasOwnProperty.call(e,r)&&t.indexOf(r)<0&&(o[r]=e[r]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var n=0;for(r=Object.getOwnPropertySymbols(e);n<r.length;n++)t.indexOf(r[n])<0&&Object.prototype.propertyIsEnumerable.call(e,r[n])&&(o[r[n]]=e[r[n]])}return o}(e,["children"]);return t().createElement(n.TableBase,Object.assign({},r),o)}c.Head=n.Head,c.Body=n.Body,c.Row=i.default,c.Cell=a.default,c.Footer=n.Footer;const d=c})(),r})()));
//# sourceMappingURL=index.js.map